module.exports = __webpack_public_path__ + "static/media/badela-satsang.92913ddb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/badela-satsang.jpeg
// module id = 509
// module chunks = 0